// Global
import React from 'react';
import clsx from 'clsx';

// Local
import styles from './PreambleLinkList.module.scss';
import { BrandAndThemeProvider } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import { Themes } from 'lib/themes';
import {
  Preamble,
  PreambleOrientation,
  PreambleProps,
} from 'components/helpers/Molecules/Preamble/Preamble';

export interface PreambleLinkListProps {
  className?: string;
  theme?: Themes;
  preamble?: PreambleProps;
  preambleOrientation?: PreambleOrientation;
  content?: React.ReactNode;
}

export const PreambleLinkListBase = (props: PreambleLinkListProps) => {
  const preambleAlignment = props.preambleOrientation ?? props.preamble?.align;

  return (
    <div
      className={clsx(styles.preambleLinkList, props.className)}
      data-component="authorable/shared/content/preamble-link-list/preamble-link-list"
    >
      <Preamble {...props.preamble} align={preambleAlignment}>
        <div
          className={clsx(styles.contentPanel, {
            [styles.contentPanelForSideLeft]: preambleAlignment === 'SideLeft',
            [styles.contentPanelForTopCenter]: preambleAlignment === 'TopCenter',
          })}
        >
          {props.content}
        </div>
      </Preamble>
    </div>
  );
};

export const PreambleLinkList = (props: PreambleLinkListProps) => {
  return (
    <BrandAndThemeProvider theme={props.theme} className={styles.preambleLinkListWrapper}>
      <PreambleLinkListBase {...props} />
    </BrandAndThemeProvider>
  );
};
